import { motion } from 'framer-motion';
import { useLocation } from 'wouter';
import { AttributeBadge } from '@/components/games/attribute-badge';
import { DifficultyBadge } from './difficulty-badge';
import type { HomeGame } from '@/types/game';

interface GameCardProps {
  game: HomeGame;
  hidePrice?: boolean;
}

export function GameCard({ game, hidePrice = false }: GameCardProps) {
  const [, navigate] = useLocation();

  const handleNavigate = () => navigate(`/game/${game.id}`);

  return (
    <motion.div
      transition={{ duration: 0.2 }}
      className={`w-full h-auto overflow-visible relative @container/gameCard`}
      whileHover={{ scale: 1.02 }}
    >
      <div
        onClick={handleNavigate}
        className="aspect-video relative cursor-pointer overflow-hidden rounded-md @lg/gameCard:rounded-lg transition-colors border-customPurple-700 border hover:border-customPurple-500"
      >
        <img
          loading="lazy"
          src={game.thumbnailUrl || 'https://placehold.co/600x400/363062/FFFFFF/svg'}
          alt={game.title}
          className="w-full h-full object-cover"
        />
        <DifficultyBadge level={game.difficulty} className="absolute left-2 top-2 font-medium" />
        {!hidePrice && (
          <AttributeBadge
            label={game.isFree ? 'Бесплатно' : `${game.price} ₽`}
            className="absolute top-2 right-2 font-bold"
          />
        )}
      </div>
    </motion.div>
  );
}
